module.exports = __webpack_public_path__ + "img/画板 5.9fe5066c.jpg";